import { UIMatch } from "react-router-dom";
import { RouteHandle } from "types/router";
import { NavigationItem } from "./types";

export const pathMatchesRoute =
  (item: NavigationItem) => (match: UIMatch<unknown, RouteHandle>) => {
    const path = `/${item.path}`;
    return match.pathname === path || match.handle?.parent?.path === path;
  };
